import React from "react";
import { Link } from "react-router-dom";

function Navlist() {
  return (
        <ul>
          <Link to="/">
            <li>Home</li>
          </Link>
          <Link to="/book">
            <li>Book</li>
          </Link>
          <Link to="/services">
            <li>Services</li>
          </Link>
          <Link to="/about">
            <li>About</li>
          </Link>
          <Link to="/contact">
            <li>Contact</li>
          </Link>
        </ul>
  );
}

export default Navlist;
